module.exports = __webpack_public_path__ + "static/logot-829fe2892ec2bd0f277e3e84d49d537d.svg";